import type { Driver } from '#domain/model/Driver.ts';
import type { Tour, TourStatus } from '#domain/model/Tour.ts';

const TourStatusWeight: Record<NonNullable<TourStatus>, number> = {
    problem: 1,
    'in-transit': 2,
    planned: 3,
    open: 4,
    finished: 5,
};

export const mapTourStatusToOrderStatusWeight = (status: TourStatus | undefined): number =>
    status ? TourStatusWeight[status] : 5;

export type TourWithSortableKey = Tour & {
    statusWeight: number;
    firstStopEndTarget?: string;
    lastStopEndTarget?: string;
    progressPercentage?: number;
    truckLicensePlate?: string;
    trailerLicensePlate?: string;
    driverName?: string;
};

// We need to add new keys only used for sorting the items (its not supported to do sorting on nested objects)
export const addSortableTourKey = (items: Tour[], drivers?: Driver[]): TourWithSortableKey[] =>
    items.map(tour => ({
        ...tour,
        firstStopEndTarget: tour.firstStop?.endTarget,
        lastStopEndTarget: tour.lastStop?.endTarget,
        progressPercentage:
            tour.progress.totalStopAmount > 0
                ? (tour.progress.finishedStopAmount / tour.progress.totalStopAmount) * 100
                : 0,
        truckLicensePlate: tour.truck.licensePlate,
        trailerLicensePlate: tour.trailer?.licensePlate,
        driverName: drivers ? getTourDriver(tour, drivers)?.name : undefined,
        statusWeight: mapTourStatusToOrderStatusWeight(tour.status),
    }));

export const getTourDriver = (tour: Tour, drivers: Driver[]) => drivers.find(driver => driver.id === tour.driverId);
